import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "row" }

import { ref, defineAsyncComponent } from 'vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'indexInputs',
  setup(__props) {

const basicForm = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/basicForm.vue"))
const floatingForm = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/floatingForm.vue"))
const selectSizing = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/selectSizing.vue"))
const fileInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/fileInput.vue"))
const flatInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/flatInput.vue"))
const htmlInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/htmlInput.vue"))
const floatingInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/floatingInput.vue"))
const edgesInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/edgesInput.vue"))
const raiseInput = defineAsyncComponent(() => import("@/components/theme/forms/formcontrol/input/raiseInput.vue"))

return (_ctx: any,_cache: any) => {
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Breadcrumbs, {
      main: "Form Controls",
      title: "Base Inputs"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(basicForm)),
        _createVNode(_unref(floatingForm)),
        _createVNode(_unref(selectSizing)),
        _createVNode(_unref(fileInput)),
        _createVNode(_unref(flatInput)),
        _createVNode(_unref(htmlInput)),
        _createVNode(_unref(floatingInput)),
        _createVNode(_unref(edgesInput)),
        _createVNode(_unref(raiseInput))
      ])
    ])
  ], 64))
}
}

})